import React, {useEffect, useState} from 'react';
import {connect} from 'react-redux';
import {compose} from 'redux';
import {addPurpose, setPurposes} from '../../../store/actions';
import colors from '../../../util/colors';
import {Icons} from '../../../util/icons';
import {createClassName} from '../../../util/utility';
import Icon from '../../icon';
import {Column} from '../../layout';

import './styles.scss';

interface AppCheckboxInputProps extends React.HTMLProps<HTMLDivElement> {
  label?: any;
  labelClass?: string;
  onChange(value: any): void;
  checked: boolean;
  className?: string;
  buStyles: any;
  setPurposes(value: any): void;
  addPurpose(value: any): void;
  onClick?(): void;
  disabled?: boolean;
  purposeId?: string;
  purposes?: any;
  defaultColor?: boolean;
}

function AppCheckboxInput(props: AppCheckboxInputProps) {
  const {
    label,
    onChange,
    labelClass,
    className,
    checked,
    name,
    onClick,
    buStyles,
    disabled,
    defaultColor = false,
    purposeId,
    purposes,
    setPurposes,
    addPurpose,
    ...rest
  } = props;
  const classes = createClassName('app-checkbox-input-container', className);
  const [isChecked, setIsChecked] = useState(checked);

  const removePurpose = (purposeIdToRemove: any) => {
    var purposesList: any[] = purposes;
    var filteredPurposesList = purposesList.filter(
      (p: any) => p.Id != purposeIdToRemove
    );
    setPurposes(filteredPurposesList);
  };

  useEffect(() => {
    setIsChecked(checked);

    if (purposeId)
      if (isChecked) addPurpose({Id: purposeId});
      else removePurpose(purposeId);
  }, [checked]);

  return disabled ? (
    <div className={classes} id={`app-checkbox-${name}`} {...rest}>
      <Column
        className="app-checkbox-input-column"
        style={{
          border: `solid '1px' ${buStyles?.primaryColor || colors.blue}`,
          marginRight: !!!label || label === '' ? 0 : '5px',
          color: `${buStyles?.primaryColor || colors.blue}`,
        }}>
        {isChecked && (
          <Icon
            className="app-checkbox-input-icon"
            name={Icons.ROUNDED_CHECK}
            color={buStyles?.primaryColor || colors.blue}
            preserveAspectRatio={'none'}
            changeViewbox={true}
            height="14.85"
            width="15.01"
          />
        )}
      </Column>
      {!!label && label !== '' && (
        <Column className={labelClass ? labelClass : 'centered-label'}>
          {label}
        </Column>
      )}
    </div>
  ) : (
    <div className={classes} id={`app-checkbox-${name}`} {...rest}>
      <Column
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          onChange(!isChecked);
          setIsChecked(!isChecked);
          if (onClick) {
            onClick();
          }
        }}
        className="app-checkbox-input-column"
        style={{
          border: `solid '1px' ${buStyles?.primaryColor || colors.blue}`,
          marginRight: !!!label || label === '' ? 0 : '5px',
          color: `${buStyles?.primaryColor || colors.blue}`,
        }}>
        {isChecked && (
          <Icon
            className="app-checkbox-input-icon"
            name={Icons.ROUNDED_CHECK}
            color={buStyles?.primaryColor || colors.blue}
            preserveAspectRatio={'none'}
            changeViewbox={true}
            height="14.85"
            width="15.01"
          />
        )}
      </Column>
      {!!label && label !== '' && (
        <Column className={labelClass ? labelClass : 'centered-label'}>
          {label}
        </Column>
      )}
    </div>
  );
}

const mapStateToProps = ({globalStyles, purposes}: any) => ({
  buStyles: globalStyles.value,
  purposes: purposes.value,
});

const mapDispatchToProps = (dispatch: any) => ({
  setPurposes: (value: any) => dispatch(setPurposes(value)),
  addPurpose: (value: any) => dispatch(addPurpose(value)),
});

export default compose(
  connect(mapStateToProps, mapDispatchToProps)(AppCheckboxInput)
);
